import type { Static } from 'runtypes';
import { Literal, Union } from 'runtypes';

const literals = [
  Literal('artifact_versions'),
  Literal('attachments'),
  Literal('boards'),
  Literal('briefs'),
  Literal('c2_units'),
  Literal('c2_unit_states'),
  Literal('c2_rels'),
  Literal('c2_rel_types'),
  Literal('comment_threads'),
  Literal('comments'),
  Literal('documents'),
  Literal('edges'),
  Literal('frames'),
  Literal('file_documents'),
  Literal('icons'),
  Literal('key_dates'),
  Literal('lists'),
  Literal('map_overlays'),
  Literal('maps'),
  Literal('nodes'),
  Literal('orders'),
  Literal('presentations'),
  Literal('presentation_slides'),
  Literal('sections'),
  Literal('unit_emblems'),
  Literal('whiteboards'),
  Literal('node_fields'),
  Literal('node_field_sets'),
  Literal('action_items'),
  Literal('workflows'),
  Literal('wargame_aars'),
] as const;

const otArtifactTypes = literals.map((l) => l.value);

const OTArtifactRunType = Union(...literals);
type OTArtifactType = Static<typeof OTArtifactRunType>;

type OTArtifactIdMap = Partial<Record<OTArtifactType, number[]>>;

export { OTArtifactRunType, otArtifactTypes, otArtifactTypes as OTArtifactTypes };
export type { OTArtifactType, OTArtifactIdMap };
